// modules
import React, { useState, useEffect } from "react";
import "../styles/Country.scss";
import ReactCountryFlag from "react-country-flag";

export const REGION_TO_COUNTRY = {
  af: { code: "AF", name: "Afghanistan" },
  al: { code: "AL", name: "Albania" },
  dz: { code: "DZ", name: "Algeria" },
  ad: { code: "AD", name: "Andorra" },
  ao: { code: "AO", name: "Angola" },
  ar: { code: "AR", name: "Argentina" },
  am: { code: "AM", name: "Armenia" },
  au: { code: "AU", name: "Australia" },
  at: { code: "AT", name: "Austria" },
  az: { code: "AZ", name: "Azerbaijan" },

  bs: { code: "BS", name: "Bahamas" },
  bh: { code: "BH", name: "Bahrain" },
  bd: { code: "BD", name: "Bangladesh" },
  by: { code: "BY", name: "Belarus" },
  be: { code: "BE", name: "Belgium" },
  bz: { code: "BZ", name: "Belize" },
  bj: { code: "BJ", name: "Benin" },
  bt: { code: "BT", name: "Bhutan" },
  bo: { code: "BO", name: "Bolivia" },
  ba: { code: "BA", name: "Bosnia and Herzegovina" },
  bw: { code: "BW", name: "Botswana" },
  br: { code: "BR", name: "Brazil" },
  bn: { code: "BN", name: "Brunei" },
  bg: { code: "BG", name: "Bulgaria" },
  bf: { code: "BF", name: "Burkina Faso" },
  bi: { code: "BI", name: "Burundi" },

  kh: { code: "KH", name: "Cambodia" },
  cm: { code: "CM", name: "Cameroon" },
  ca: { code: "CA", name: "Canada" },
  cv: { code: "CV", name: "Cape Verde" },
  cf: { code: "CF", name: "Central African Republic" },
  td: { code: "TD", name: "Chad" },
  cl: { code: "CL", name: "Chile" },
  cn: { code: "CN", name: "China" },
  co: { code: "CO", name: "Colombia" },
  km: { code: "KM", name: "Comoros" },
  cg: { code: "CG", name: "Congo" },
  cd: { code: "CD", name: "Congo (Democratic Republic)" },
  cr: { code: "CR", name: "Costa Rica" },
  ci: { code: "CI", name: "Côte d’Ivoire" },
  hr: { code: "HR", name: "Croatia" },
  cu: { code: "CU", name: "Cuba" },
  cy: { code: "CY", name: "Cyprus" },
  cz: { code: "CZ", name: "Czech Republic" },

  dk: { code: "DK", name: "Denmark" },
  dj: { code: "DJ", name: "Djibouti" },
  do: { code: "DO", name: "Dominican Republic" },

  eu: { code: "EU", name: "Europe" },
  ec: { code: "EC", name: "Ecuador" },
  eg: { code: "EG", name: "Egypt" },
  sv: { code: "SV", name: "El Salvador" },
  gq: { code: "GQ", name: "Equatorial Guinea" },
  er: { code: "ER", name: "Eritrea" },
  ee: { code: "EE", name: "Estonia" },
  et: { code: "ET", name: "Ethiopia" },

  fi: { code: "FI", name: "Finland" },
  fr: { code: "FR", name: "France" },

  ga: { code: "GA", name: "Gabon" },
  gm: { code: "GM", name: "Gambia" },
  ge: { code: "GE", name: "Georgia" },
  de: { code: "DE", name: "Germany" },
  gh: { code: "GH", name: "Ghana" },
  gr: { code: "GR", name: "Greece" },
  gt: { code: "GT", name: "Guatemala" },
  gn: { code: "GN", name: "Guinea" },

  ht: { code: "HT", name: "Haiti" },
  hn: { code: "HN", name: "Honduras" },
  hk: { code: "HK", name: "Hong Kong" },
  hu: { code: "HU", name: "Hungary" },

  is: { code: "IS", name: "Iceland" },
  in: { code: "IN", name: "India" },
  id: { code: "ID", name: "Indonesia" },
  ir: { code: "IR", name: "Iran" },
  iq: { code: "IQ", name: "Iraq" },
  ie: { code: "IE", name: "Ireland" },
  il: { code: "IL", name: "Israel" },
  it: { code: "IT", name: "Italy" },

  jp: { code: "JP", name: "Japan" },
  jo: { code: "JO", name: "Jordan" },

  ke: { code: "KE", name: "Kenya" },
  kr: { code: "KR", name: "South Korea" },
  kw: { code: "KW", name: "Kuwait" },

  lv: { code: "LV", name: "Latvia" },
  lb: { code: "LB", name: "Lebanon" },
  lt: { code: "LT", name: "Lithuania" },
  lu: { code: "LU", name: "Luxembourg" },

  my: { code: "MY", name: "Malaysia" },
  mx: { code: "MX", name: "Mexico" },
  ma: { code: "MA", name: "Morocco" },

  nl: { code: "NL", name: "Netherlands" },
  nz: { code: "NZ", name: "New Zealand" },
  ng: { code: "NG", name: "Nigeria" },
  no: { code: "NO", name: "Norway" },

  pk: { code: "PK", name: "Pakistan" },
  pa: { code: "PA", name: "Panama" },
  pe: { code: "PE", name: "Peru" },
  ph: { code: "PH", name: "Philippines" },
  pl: { code: "PL", name: "Poland" },
  pt: { code: "PT", name: "Portugal" },

  qa: { code: "QA", name: "Qatar" },

  ro: { code: "RO", name: "Romania" },
  ru: { code: "RU", name: "Russia" },

  sa: { code: "SA", name: "Saudi Arabia" },
  sn: { code: "SN", name: "Senegal" },
  rs: { code: "RS", name: "Serbia" },
  sg: { code: "SG", name: "Singapore" },
  sk: { code: "SK", name: "Slovakia" },
  si: { code: "SI", name: "Slovenia" },
  za: { code: "ZA", name: "South Africa" },
  es: { code: "ES", name: "Spain" },
  se: { code: "SE", name: "Sweden" },
  ch: { code: "CH", name: "Switzerland" },

  th: { code: "TH", name: "Thailand" },
  tn: { code: "TN", name: "Tunisia" },
  tr: { code: "TR", name: "Turkey" },

  ua: { code: "UA", name: "Ukraine" },
  ae: { code: "AE", name: "United Arab Emirates" },
  gb: { code: "GB", name: "United Kingdom" },
  us: { code: "US", name: "United States" },

  uy: { code: "UY", name: "Uruguay" },
  uz: { code: "UZ", name: "Uzbekistan" },

  ve: { code: "VE", name: "Venezuela" },
  vn: { code: "VN", name: "Vietnam" },

  zm: { code: "ZM", name: "Zambia" },
  zw: { code: "ZW", name: "Zimbabwe" }
};


function getCountryCode() {
 const countrycode = window._env_?.REACT_APP_ALFA2_COUNTRY_CODE;
  if (!countrycode) return null;
  return countrycode;
}

const Country = () => {
  const [region, setRegion] = useState(null);

  useEffect(() => {
    const r = getCountryCode();
    setRegion(r);
  }, []);

  // ❗ guard: avoid crash if region not ready or unknown
  if (!region || !REGION_TO_COUNTRY[region]) {
    return null; // or a loader if you prefer
  }

  const { code, name } = REGION_TO_COUNTRY[region];

  return (
    <div className="c-main-container">
      <ReactCountryFlag
        countryCode={code}
        svg
        style={{
          width: "32px",
          height: "32px",
          borderRadius: "50%",
          objectFit: "cover",
        }}
      />
      <span className="c-text">{name.toUpperCase()}</span>
    </div>
  );
};

export default Country;
